import { render, staticRenderFns } from "./category-filter.vue?vue&type=template&id=b5a69e28&scoped=true"
import script from "./category-filter.vue?vue&type=script&lang=js"
export * from "./category-filter.vue?vue&type=script&lang=js"
import style0 from "./category-filter.vue?vue&type=style&index=0&id=b5a69e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a69e28",
  null
  
)

export default component.exports